$(document).ready(function() {
	if ($("code-scanner").length === 0) {
		return;
	}

	if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && "BarcodeDetector" in window)) {
		return;
	}


	let $codeScanner = $("code-scanner");
	let $video = $("code-scanner > camera-stream > video");
	let $canvas = $("code-scanner > peephole > canvas");
	let $form = $("#frm-loadTicketForm");
	let $codeInput = $("#frm-loadTicketForm-code");
	let $loadButton = $("#frm-loadTicketForm input[name=load]");
	let canvasContext = $canvas[0].getContext("2d");
	let constraints = {audio: false, video: {width: {ideal: 1080}, facingMode: {exact: "environment"}}};
	let barcodeDetector = new BarcodeDetector({formats: ["ean_13", "qr_code"]});
	let drawPeepholeRequestId;
	let detectCodeIntervalId;
	let activateCodeScannerTimeoutId;


	navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
		$video[0].srcObject = stream;

		activateCodeScanner();

		$codeInput.on("focus", deactivateCodeScanner);

		$loadButton.click(stopRoutines);

		$codeInput.on("blur", () => {
			if (activateCodeScannerTimeoutId !== undefined) {
				return;
			}

			activateCodeScannerTimeoutId = setTimeout(activateCodeScanner, 150);
		});
	});


	let drawPeephole = () => {
		let ratio = canvasContext.canvas.width / $video.width();
		let imageWidth = $video.width() * ratio;
		let imageHeight = $video.height() * ratio;

		if (Math.round(imageHeight) < Math.round(canvasContext.canvas.height)) {
			ratio = canvasContext.canvas.height / $video.height();
			imageWidth = $video.width() * ratio;
			imageHeight = $video.height() * ratio;
			let x = (imageWidth - canvasContext.canvas.width) / -2;

			canvasContext.drawImage($video[0], x, 0, imageWidth, imageHeight);
		}
		else {
			let y = (imageHeight - canvasContext.canvas.height) / -2;

			canvasContext.drawImage($video[0], 0, y, imageWidth, imageHeight);
		}

		drawPeepholeRequestId = requestAnimationFrame(drawPeephole);
	};


	let detectCode = () => {
		barcodeDetector.detect($video[0]).then(codes => {
			if (codes.length === 0) {
				return;
			}

			for (let codeData of codes) {
				let codeMatch = codeData.rawValue.match(/([0-9]{13})$/);

				if (codeMatch !== null) {
					$codeInput.val(codeMatch[1]);

					stopRoutines();
					$form.submit();

					break;
				}
			}
		});
	};


	let activateCodeScanner = () => {
		stopRoutines();

		$video[0].play();
		$codeScanner.addClass("active");
		drawPeephole();
		detectCodeIntervalId = setInterval(detectCode, 100);
	};


	let deactivateCodeScanner = () => {
		stopRoutines();
		$codeScanner.removeClass("active");
	};


	let stopRoutines = () => {
		$video[0].pause();

		if (activateCodeScannerTimeoutId !== undefined) {
			clearTimeout(activateCodeScannerTimeoutId);
			activateCodeScannerTimeoutId = undefined;
		}

		if (drawPeepholeRequestId !== undefined) {
			cancelAnimationFrame(drawPeepholeRequestId);
			drawPeepholeRequestId = undefined;
		}

		if (detectCodeIntervalId !== undefined) {
			clearInterval(detectCodeIntervalId);
			detectCodeIntervalId = undefined;
		}
	};
});
